import { Badge, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useDroppable } from '@dnd-kit/core';
import TicketCard from '../TicketCard';
import { IRequestSupport } from '../../interfaces/apis';
import styled from 'styled-components';
import { ERequestSupportStatus, RequestSupportStatusConfig } from 'pages/request-support/services/constants';

interface BoardColumnProps {
  column: IRequestSupport;
  handleOpenChangeAssignModal: (assignId: string, ticketId: string) => void;
  onOpenAddRequestModal: () => void;
  onOpenDetailRequestModal: (ticketId: string) => void;
}

const BoardColumn = ({ column, handleOpenChangeAssignModal, onOpenAddRequestModal, onOpenDetailRequestModal }: BoardColumnProps) => {
  const { setNodeRef, isOver } = useDroppable({
    id: column.status,
  });


  return (
    <Container>
      <Header style={{
        backgroundColor: RequestSupportStatusConfig[column.status as ERequestSupportStatus]?.background,
      }}>
        <Title>
          {RequestSupportStatusConfig[column.status as ERequestSupportStatus]?.title || column.status}

          <Badge
            count={column.tickets.length}
            className='style-count'
            style={{
              backgroundColor: RequestSupportStatusConfig[column.status as ERequestSupportStatus]?.color,
              color: '#FFF',
              fontSize: 14,
              border: 'none',
              boxShadow: 'none',
              borderRadius: '999px',
            }}
            showZero
          />
        </Title>
        { column.status === ERequestSupportStatus.NEW && (
          <Button type='text' icon={<PlusOutlined size={40}/>} onClick={onOpenAddRequestModal} className='add-button'/>
        )}
      </Header>
      <DropArea ref={setNodeRef} isOver={isOver}>
        <SortableContext items={column.tickets.map((ticket) => ticket.id)} strategy={verticalListSortingStrategy}>
          {column.tickets.map((ticket) => (
            <TicketCard 
              key={ticket.id} 
              ticket={ticket} 
              handleOpenChangeAssignModal={handleOpenChangeAssignModal} 
              onOpenDetailRequestModal={onOpenDetailRequestModal}
              status={column.status}
            />
          ))}
        </SortableContext>
      </DropArea>
    </Container>
  );
};

export default BoardColumn;

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  background: #F1F2F4;
  box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const DropArea = styled.div<{
  isOver: boolean;
}>`
  flex: 1;
  min-height: 0;
  background: ${(props) => (props.isOver ? '#e6f4ff' : 'transparent')};
  transition: 0.2s;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;

  &::-webkit-scrollbar {
  width: 6px;
}

&::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 999px;
}
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  height: 56px;

  .add-button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    width: 32px;
    height: 32px;
    background: #FFF;

    .anticon {
      font-size: 20px;
    }
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  font-weight: 500;
  font-size: 14px;
  font-family: 'Poppins';

  .style-count {
    .ant-badge-count {
      height: 24px;
      min-width: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
`;
